import { Injectable } from '@angular/core';
import { Role } from '../model';
import { BaseService } from '../../shared/baseService';
@Injectable({
    providedIn: 'root'
})

export class RolesService extends BaseService<Role> {
  
    constructor() {
        super('Role');
    }
}
